import { setAuthToken } from '../../../services/api';

const STORAGE_KEY = 'tuma_auth';

export function getAuth() {
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    return raw ? JSON.parse(raw) : null;
  } catch (e) {
    return null;
  }
}

export function setAuth(auth) {
  localStorage.setItem(STORAGE_KEY, JSON.stringify(auth));
  setAuthToken(auth?.token);
}

export function clearAuth() {
  localStorage.removeItem(STORAGE_KEY);
  setAuthToken(null);
}

export function initAuthFromStorage() {
  const auth = getAuth();
  if (auth?.token) {
    setAuthToken(auth.token);
  }
  return auth;
}

